import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-full w-full h-full" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass([
                  'absolute top-1/2 left-full transform -translate-y-1/2 translate-x-2 font-roboto-condensed text-zbr-black-900 text-xs whitespace-nowrap',
                  'invisible opacity-0 transition-opacity duration-300 ease',
                  'group-hover:visible group-hover:opacity-100',
                ])
}
const _hoisted_5 = { class: "font-roboto-condensed text-[#4B5563] text-[14px]" }
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass([
        'grid grid-cols-1 w-full h-[98%]',
        'xl:grid-cols-3 xl:gap-x-4 xl:pt-5'
      ])
}
const _hoisted_7 = {
  key: 0,
  class: "w-full h-auto",
  controls: ""
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "absolute top-0 left-0 h-full w-full backdrop-blur z-40"
}

import SearchByManufacturers from '@/components/SearchByManufacturers.vue';
import SearchByMotorcycleType from '@/components/SearchByMotorcycleType.vue';
import SearchHistory from '@/components/SearchHistory.vue';
import VehicleSearchStartTablet from '@/components/VehicleSearchStartTablet.vue';
import IconInformation from '@/components/icons/IconInformation.vue';
import IconAlert from '@/components/icons/IconAlert.vue';
import { useScreenSize } from '@/composables/useScreenSize';
import { useDialogStore } from '@/stores/useDialogStore';
import { useUserStore } from '@/stores/useUserStore';
import { storeToRefs } from 'pinia';
import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { isTablet } = useScreenSize();
const breadcrumbItems = [
  { label: 'HOME', link: 'start-page', slot: 'home' },
];

const dialogStore = useDialogStore();
const userStore = useUserStore();
const { userData } = storeToRefs(userStore);
const isOpenVideo = ref(false);

onMounted(() => {
  if (userData.value.vehicleSearchApproval === null || userData.value.vehicleSearchApproval === false) {
    dialogStore.setShowDialog('vehicleSearchApprovalDialog', true);
  }
});

function onOpenVideoSample() {
  isOpenVideo.value = true;
  dialogStore.setShowDialog('vehicleSearchVideoSample', true);
}
function onCloseVideoSample() {
  isOpenVideo.value = false;
}
function onClickDisclaimer() {
  dialogStore.setShowDialog('vehicleSearchApprovalDialog', true);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_breadcrumb = _resolveComponent("base-breadcrumb")!
  const _component_base_modal_dialog = _resolveComponent("base-modal-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_breadcrumb, { items: breadcrumbItems }, {
          "link-home": _withCtx(({ link, query, label }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: {
                name: link,
                query: query ? query : null
              },
                class: "mr-2 font-roboto-condensed text-zbr-black-900 text-xs hover:underline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(label)), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("button", {
                class: "relative group",
                onClick: onOpenVideoSample
              }, [
                _createVNode(IconInformation, {
                  "class-name": "inline-block",
                  "class-fill": "text-zbr-gray-700",
                  size: 15
                }),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('VEHICLE-SEARCH-VIDEO')), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          class: "vehicle-search-approval-btn relative z-[48]",
          onClick: onClickDisclaimer
        }, [
          _createVNode(IconAlert),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('LEGAL-DISCLAIMER-HEADLINE')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(isTablet))
          ? (_openBlock(), _createBlock(VehicleSearchStartTablet, { key: 0 }, {
              "tab-0": _withCtx(() => [
                _createVNode(SearchByManufacturers, { "no-title": "" })
              ]),
              "tab-1": _withCtx(() => [
                _createVNode(SearchByMotorcycleType, { "no-title": "" })
              ]),
              "tab-2": _withCtx(() => [
                _createVNode(SearchHistory, { "no-title": "" })
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(SearchByManufacturers),
              _createVNode(SearchByMotorcycleType),
              _createVNode(SearchHistory)
            ], 64))
      ]),
      _createVNode(_component_base_modal_dialog, {
        "width-class": "w-[95%] xl:w-10/12",
        "max-width-class": "xl:max-w-[1100px]",
        "modal-key": "vehicleSearchVideoSample",
        onOnClose: onCloseVideoSample
      }, {
        default: _withCtx(() => [
          (isOpenVideo.value)
            ? (_openBlock(), _createElementBlock("video", _hoisted_7, [
                _createElementVNode("source", {
                  src: require('@/assets/video-sample.mp4'),
                  type: "video/mp4"
                }, null, 8, _hoisted_8),
                _createTextVNode(" Your browser does not support HTML video. ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_unref(userData).vehicleSearchApproval === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : _createCommentVNode("", true)
  ], 64))
}
}

})